import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import Routes from "Routes";
import store from "Store";
import { AuthProvider } from "./hooks/useAuth";
import { ThemeProvider } from "./context/ThemeContext";
import { ThemeSync } from "./context/ThemeSync";
import { TooltipProvider } from "Components/ui";
import { IconProvider } from "Components/ui/icons";

const queryClient = new QueryClient();

const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <IconProvider>
          <TooltipProvider delayDuration={300}>
            <AuthProvider>
              <ThemeSync />
              <QueryClientProvider client={queryClient}>
                <Routes />
              </QueryClientProvider>
            </AuthProvider>
          </TooltipProvider>
        </IconProvider>
      </ThemeProvider>
    </Provider>
  );
};
export default App;
